/**
 * MessagingDialog Sub-Component (extracted 2026-07 refactor).
 *
 * Rendert die Empfänger-Chips-Box in der Sidebar, wenn ein Rundschreiben
 * oder Wizard-Kontext > 1 Empfänger enthält. Rein präsentational.
 */
export default function WizardRecipientChips({ wizardRecipients, rundschreiben, rundschreibenMode }) {
  if (!wizardRecipients || wizardRecipients.length === 0) return null;
  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-md p-2 space-y-1.5" data-testid="msg-wizard-recipients">
      <div className="text-[10px] uppercase tracking-wider font-semibold text-emerald-900 flex items-center justify-between">
        <span>Empfänger ({wizardRecipients.length}) {rundschreiben && wizardRecipients.length > 1 && "· Rundschreiben"}</span>
        {rundschreiben && rundschreibenMode === "per_empfaenger" && (
          <span className="text-[9px] font-normal text-emerald-700 normal-case italic">1 Brief pro Empfänger</span>
        )}
      </div>
      <div className="flex flex-wrap gap-1 max-h-24 overflow-y-auto">
        {wizardRecipients.map((r) => (
          <span
            key={r.key || r.tenancy_id || r.contact_id}
            className="text-[10px] bg-white border border-emerald-200 px-2 py-0.5 rounded-full font-medium text-slate-700 truncate max-w-[220px]"
            title={r.name}
            data-testid={`msg-chip-${r.key || r.tenancy_id || r.contact_id}`}
          >
            {r.name}
          </span>
        ))}
      </div>
    </div>
  );
}
